import React from 'react';
import './LandmarksPage.css';
import LandmarksEdaPage from './LandmarksEdaPage';

const LandmarksPage: React.FC = () => {
  return (
    <div className="page-container">
      <div className="landmarks-analysis">
        <h2>Landmarks Analysis</h2>
        <LandmarksEdaPage />
      </div>
    </div>
  );
};

export default LandmarksPage;
